/**
 * EmptyMainText component.
 */
import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const EmptyMainText = styled.span<React.CSSProperties>`
  align-items: center;
  color: ${Colors['light']};
  font-family: ${Fonts['regular']};
  font-size: ${40 * Screen.widthRatio}px;
  height: fit-content;
  justify-content: center;
  position: absolute;
  text-align: center;
  width: ${920 * Screen.widthRatio}px;
`;

export default EmptyMainText;
